<template>
  <img src="../../../assets/img/avatars/avatar2.jpg" alt="avatar2">
</template>
